
const state = {
    chartofaccount: [],
    id: [],
    loading: false
};

export default state;